<template>
  <b-tabs>
    <b-tab-item label="My Treasure Minings" icon="fingerprint">
      <b-tabs position="is-centered" >
        <b-tab-item label="Current Treasure Minings" icon="clock">
          <div class="columns is-multiline is-mobile" v-if="loadPlan">
            <div
              class="column is-6-desktop is-12-mobile"
              v-for="plan in myPlansGrowing()"
              :key="'g'+plan.id" 
            >
              <Plan :plan="plan" @onChanged="planChanged"></Plan>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="Mined Treasures" icon="diamond">
          <div class="columns is-multiline is-mobile" v-if="loadPlan">
            <div
              class="column is-6-desktop is-12-mobile"
              v-for="plan in myPlansHarvestable()"
              :key="'h'+plan.id"
            >
              <Plan :plan="plan" @onChanged="planChanged"></Plan>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="Treasures Collected To Vault" icon="treasure-chest">
          <div class="columns is-multiline is-mobile" v-if="loadPlan">
            <div
              class="column is-6-desktop is-12-mobile"
              v-for="plan in myPlansCompleted()"
              :key="'c'+plan.id"
            >
              <Plan :plan="plan" @onChanged="planChanged"></Plan>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </b-tab-item>

    <b-tab-item label="My Treasure Vault" icon="bank">
      <div class="my-element-control columns is-centered is-vcentered">
        <b-loading class="loading" :is-full-page="false" :active.sync="isLoadingBalance"></b-loading>

        <div class="column is-one-quarter">
          <b-button @click="reloadBalance" icon-left="refresh">Reload my balance</b-button>
        </div>
        <div class="column is-one-quarter">
          <b-checkbox v-model="showBlank">Show blank balance</b-checkbox>
        </div>
      </div>

      <div class="columns is-multiline is-variable is-1 is-mobile" v-if="showBalance">
        <div class="column is-2-desktop is-6-mobile" v-for="element in elements()" :key="element.id">
          <Element :element="element" isMyElement :showBlank="showBlank"></Element>
        </div>
      </div>
    </b-tab-item>
  </b-tabs>
</template>

<script>
import Element from "@/components/Element";
import Plan from "@/components/Plan.vue";
import contract from "./../Utils/Contract.js";

export default {
  components: { Element, Plan },
  data() {
    return {
      showBlank: true,
      planFilter: "harvestable",
      planKey: 1,
      loadPlan: false,
      showBalance: false,
      isLoadingBalance: false,
    };
  },
  async mounted() {
    this.reloadBalance();
    await contract.loadNewPlans(this.$store.state.myAddress);
    this.loadPlan = true;
  },
  computed: {
    
  },
  methods: {
    myPlansGrowing: function() {
      let self = this;
      let result = contract.plans.filter(
        plan => plan.harvestTime == 0 && !self.isHarvestable(plan)
      );
      return result;
    },
    myPlansHarvestable: function() {
      let self = this;
      let result = contract.plans.filter(
        plan => plan.harvestTime == 0 && self.isHarvestable(plan)
      );

      return result;
    },
    myPlansCompleted: function() {
      let result = contract.plans.filter(plan => plan.harvestTime != 0);
      return result;
    },
    elements: function() {
      return contract.elements;
    },
    reloadBalance: async function() {
      this.isLoadingBalance = true;
      await contract.loadBalances(this.$store.state.myAddress);
      this.showBalance = false;
      await this.$nextTick();
      this.showBalance = true;
      this.isLoadingBalance = false;
    },
    planChanged: async function(planId) {
      await contract.loadPlan(planId,this.$store.state.myAddress);
      this.loadPlan = false;
      await this.$nextTick();
      this.loadPlan = true;
    },
    isHarvestable: function(plan) {
      let startTime = new Date(plan.startTime * 1000);
      let timeToHarvest = new Date(plan.startTime * 1000);
      timeToHarvest.setMinutes(
        startTime.getMinutes() +
          contract.factories[plan.factoryId].timeToGrown -
          plan.bonusTime
      );
      return timeToHarvest < new Date(Date.now());
    }
  }
};
</script>

<style>
.my-element-control {
  margin: 10px;
  position: relative;
}
</style>
